import React, { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import Helmet from 'react-helmet';
import CabModifySearch from '../../components/CabModifySearch/CabModifySearch';
import WhyBookWithUs from '../../components/WhyBookWithUs/WhyBookWithUs';
import FaqSection from '../../components/Faq/Faq';
import TopCarTypeCabsRoutes from '../../components/TopCarTypeCabRoutes/TopCarTypeCabRoutes';
import TopCabsRoutes from '../../components/TopCabsRoutes/TopCabsRoutes';
import Footer from '../../components/Footer/Footer';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import PageHeader from '../../components/PageHeader/PageHeader';
import { trackCityCarTypeTemplateEvent } from '../../utils/omnitureTracking';
import DataLoaderError from '../../../server/errors/DataLoaderError';
import AppContextProvider from '../../AppContext';
import ThingsToKnow from '../../components/ThingsToKnow/ThingsToKnow';
import { ThrowReporter } from 'io-ts/lib/ThrowReporter';
import { PathReporter } from 'io-ts/lib/PathReporter';
import '../CityOperatorTemplate/CityOperatorTemplate.css';
import { EnvironmentVariables } from '../../types';
import { getAppEnv } from '../../../config/env';
import Overlay from '../../components/BPG/Overlay';
import { useKnowMoreDetails } from '../customHooks';
import '../MultiCityPage/MultiCityPage.css';
import {
  detectUserActivity,
  fetchAndLogXdmEvent,
  generateRequestId,
  isMobile,
  isSEM,
  useSearchWidgetHooks
} from '../../utils/commonUtils';
import {
  CityCarTypeTemplateData,
  CityCarTypeTemplateChecker
} from './CityCarTypeDataTypeChecker';
import { RouteComponentProps } from 'react-router';
import CompactList from '../../components/CompactList/CompactList';
import AdsComponent from '../../components/adsComponent';
import '../RouteCarTypeTemplate/RouteCarTypeTemplate.css';
import { SEO_CITY_CARTYPE_TEMPLATE } from '../../constants/templateConstants';
import { yeildToMainThread } from '../../scheduler';
import ProductSchema from '../../utils/ProductSchema';
import { makeServiceDeskRequest } from '../../cabsAPIs';
import {
  MINIBUS,
  SCROLL,
  TEMPO_TRAVELLER
} from '../../constants/miscellaneousConstants';
import AssistModal from '../../components/AssistModal';
import CallUsModal from '../../components/AssistModal/callUsModal';
import InboundCallBox from '../../components/InboundCall/InboundCallBox';
import TripAssistant from '../TripAssistant';
import PackagesBottomSheet from '../../components/GenerateBanner/PackagesBottomSheet';
import PackagesModal from '../../components/PackagesModal/PackagesModal';
import PackageBanner from '../../components/PackageBanner/PackageBanner';
import { OUTSTATION_ROUND_TRIP } from '../../constants/tripTypes';
import TruncateText from '../../components/CompactText/TruncateText';
import ContentList from '../../components/ContentList/ContentList';
const env = getAppEnv();
const { DATA_LOADER_URL, PUBLIC_URL } = env.raw as EnvironmentVariables;
const isSSR = typeof window === 'undefined';
const ASSISTED_FORM_DATA_LS = 'ASSISTED_FORM_DATA_LS';

type PathParamsType = {
  cityCarTypeId: string;
};
type CityCarTypeTemplateProp = RouteComponentProps<PathParamsType> & {
  data: CityCarTypeTemplateData;
};

export const h1Title = (title: string) => {
  return title.includes('Tempo') || title.includes('Mini')
    ? title.replace(' Cab', '')
    : title;
};

const runtimeTypChecker = (data: CityCarTypeTemplateData) => {
  const result = CityCarTypeTemplateChecker.decode(data);
  if (result._tag !== 'Right') {
    console.log(PathReporter.report(result));
    //  ThrowReporter.report(result);
  }
};
const CityCarTypeTemplate = ({ data }: CityCarTypeTemplateProp) => {
  // runtimeTypChecker(data);
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });

  const [
    selectedKnowMoreDetailsForMobile,
    setSelectedKnowMoreDetailsForMobile
  ] = useKnowMoreDetails(null, isMobileDevice);
  const delayedKnowMoreDetailsForMobile = async val => {
    await yeildToMainThread(() => setSelectedKnowMoreDetailsForMobile(val));
  };

  const {
    cityData,
    topRoutesfromCity,
    topRoutesToCity,
    templateData,
    otherCarTypeCabsFromSource,
    carTypeData,
    airportCabs,
    hrPackages,
    interlinks,
    aggregateRating,
    schemaMinFare,
    assistedFormOpenDelay = 10000,
    showTripAssistantButton = true,
    showTripAssistantButtonForDweb = true,
    showWhatsappWidget = true,
    whatsappWidgetDeeplink = 'https://wa.me/919951106499?text=Request%20ID%20MDRequest_id%20%0AHi,%20I%20am%20looking%20for%20a%20cab%20from%20Delhi%20to%20Agra',
    customerCareNumber = '01244781861',
    assistantWidgetText = 'You can Call Us or Chat via WhatsApp',
    showWhatsAppForAssistedForm = true,
    showCallUsWidget = false,
    showCallUsForAssistedForm = true,
    inboundCallText = 'Talk to agent (24x7)',
    inboundCallNumber = '0124 - 4781861',
    showInboundCallNumberInDesktop = true,
    semCustomerCareNumber = '',
    semInboundCallNumber = '',
    showCallusModalMweb = false,
    callusModalOpenDelay = 10000,
    showInboundNumberOnAssistedForm = true,
    couponInfo = null,
    showLeaveIntentForm = false,
    packageData,
    whatsappTooltipText,
    tripAssistanceToolTipText,
    tripType
  } = data;
  console.log('data', tripType);

  let inboundCallNumberFinal = inboundCallNumber;
  let customerCareNumberFinal = customerCareNumber;
  if (isSEM()) {
    inboundCallNumberFinal = semInboundCallNumber;
    customerCareNumberFinal = semCustomerCareNumber;
  }
  const tooltipDelay = packageData?.tooltipInfo?.delay || 3000;

  const [showWhatsAppTooltip, setShowWhatsAppTooltip] = useState(
    !!whatsappTooltipText
  );
  const [showTripAssistantTooltip, setShowTripAssistantTooltip] = useState(
    !!tripAssistanceToolTipText
  );
  const useCityInTo = !!packageData;

  const [isOverlayVisible, setIsOverlayVisible] = useState(false);

  const toggleOverlay = (isVisible: boolean) => {
    setIsOverlayVisible(isVisible);
  };
  const handleClose = () => {
    setIsBottomSheetOpen(false);
    // logRttEventLogger({omniUrlArgs:SEO_CITY_TEMPLATE, eventName: 'Cab_Packages_Bottom_Sheet_Closed', pageUrl: templateData.sampleUrl });

    trackCityCarTypeTemplateEvent('Cab_Packages_Bottom_Sheet_Closed');
  };

  const { name: carTypeName, friendlyName: carTypeNameFriendly } = carTypeData;
  console.log('carTypeName', carTypeName);
  console.log('carTypeNameFriendly', carTypeNameFriendly);
  const { name: cityName, description: cityDescription, code } = cityData;
  const doNotUseCabsKeyword =
    carTypeNameFriendly
      .toLowerCase()
      .includes(TEMPO_TRAVELLER?.toLowerCase()) ||
    carTypeNameFriendly.toLowerCase().includes(MINIBUS?.toLowerCase());

  const { travelFor, pickUpTime, dropTime } = useSearchWidgetHooks(
    SEO_CITY_CARTYPE_TEMPLATE
  );

  const [showAssistantIc, setShowAssistantIc] = useState(false);
  const [showWhatsAppIcon, setWhatsAppIcon] = useState(false);
  const [showCallUsIcon, setCallUsIcon] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const scrollPosition = useRef(0);
  const assistedFormLifeCycle = useRef(0); // 0:init,1:scroll down to threshold, 2: scroll up to threshold, and automated modal shown
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const [shouldShowPackages, setShouldShowPackages] = useState(false);

  const userActionDone = () => {
    return window?.localStorage?.getItem('userActionDone') == 'true';
  };

  useEffect(() => {
    if (showWhatsAppTooltip) {
      setTimeout(() => {
        setShowWhatsAppTooltip(false);
      }, tooltipDelay);
    }
    if (showTripAssistantTooltip) {
      setTimeout(() => {
        setShowTripAssistantTooltip(false);
      }, tooltipDelay);
    }
  });

  const setShowModalWithDelay = async val => {
    if (
      isMobile()
        ? showCallusModalMweb || showTripAssistantButton
        : showTripAssistantButtonForDweb
    ) {
      await yeildToMainThread(() =>
        requestAnimationFrame(() => setShowModal(val))
      );
    }
  };
  const showModalConsideringScrollEvents = () => {
    if (assistedFormLifeCycle.current != 2 && !userActionDone()) {
      assistedFormLifeCycle.current = 2;
      setShowModalWithDelay(true);
      const eventName =
        showCallusModalMweb && showCallUsForAssistedForm && isMobile()
          ? 'Cab_SEO_Assisted_Call_Us_Form_Shown'
          : 'Cab_SEO_Assisted_Form_Shown';
      trackCityCarTypeTemplateEvent(eventName);
    }
  };

  useEffect(() => {
    //
    const handleScroll = () => {
      scrollPosition.current = window.scrollY || window.pageYOffset;

      const scrollDownThreshold = isMobileDevice ? 500 : 900;
      const scrollUpThreshold = scrollDownThreshold - 100;

      if (
        scrollPosition.current > scrollDownThreshold &&
        assistedFormLifeCycle.current == 0
      ) {
        assistedFormLifeCycle.current = 1;
      } else if (
        scrollPosition.current < scrollUpThreshold &&
        assistedFormLifeCycle.current == 1
      ) {
        showModalConsideringScrollEvents();
      }
    };

    // If tripAssistantOpen is true in the query params then open form
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('tripAssistantOpen') === 'true') {
      showModalConsideringScrollEvents();
    }

    // Attach the scroll event listener
    window.addEventListener(SCROLL, handleScroll);
    if (window?.localStorage) {
      localStorage.removeItem(ASSISTED_FORM_DATA_LS);
    }

    openFormDueToInactivity();
    if (showCallUsWidget && isMobile()) {
      setTimeout(() => {
        trackCityCarTypeTemplateEvent('Cab_SEO_Call_Us_Icon_Shown');
      }, 500);
    }

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener(SCROLL, handleScroll);
    };
  }, []);

  const openFormDueToInactivity = () => {
    const timeDelay = showCallusModalMweb
      ? callusModalOpenDelay
      : assistedFormOpenDelay;
    setTimeout(() => {
      if (window?.localStorage && assistedFormLifeCycle.current != 2) {
        if (
          !userActionDone() &&
          isMobile() &&
          (showTripAssistantButton || showCallusModalMweb)
        ) {
          showModalConsideringScrollEvents();
        } else {
          // not show message should not be shown if modal is already shown
          const userAction = userActionDone();
          trackCityCarTypeTemplateEvent(
            `Cab_SEO_Assisted_Form_Not_Shown_userActionDone_${userAction}`
          );
        }
      }
    }, timeDelay);
  };

  useEffect(() => {
    window.addEventListener(SCROLL, listenToScroll);
    detectUserActivity();
    return () => window.removeEventListener(SCROLL, listenToScroll);
  }, []);

  useEffect(() => {
    const url =
      typeof window !== 'undefined'
        ? window.location.href
        : templateData?.sampleUrl || '';
    fetchAndLogXdmEvent(url);
  }, []);

  useEffect(() => {
    if (packageData && packageData?.show_delay) {
      const timer = setTimeout(() => {
        // const ModalOrSheetOpened = window.sessionStorage.getItem(
        //   'packageModalOrSheetOpened'
        // );
        // if (!ModalOrSheetOpened) {
        if (isMobile()) {
          //  logRttEventLogger({omniUrlArgs:`source=${SEO_CITY_TEMPLATE}`, eventName: 'Cab_Packages_Bottom_Sheet_Shown',pageUrl:templateData.sampleUrl });
          trackCityCarTypeTemplateEvent('Cab_Packages_Bottom_Sheet_Shown');
          setIsBottomSheetOpen(packageData.show_bottom_sheet_mweb);
        } else {
          // logRttEventLogger({omniUrlArgs:`source=${SEO_CITY_TEMPLATE}`, eventName: 'Cab_Packages_Modal_Shown',pageUrl:templateData.sampleUrl });
          trackCityCarTypeTemplateEvent('Cab_Packages_Modal_Shown');
          setShouldShowPackages(packageData.show_modal_dweb);
        }
        //   window.sessionStorage.setItem('packageModalOrSheetOpened', 'true');
        // }
      }, packageData.show_delay);

      return () => clearTimeout(timer);
    }
  }, [packageData]);

  const listenToScroll = () => {
    const heightToShowFrom = 100;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    if (winScroll > heightToShowFrom) {
      if (!(isMobileDevice && showModal)) {
        setShowAssistantIc(true);
        setWhatsAppIcon(true);
        setCallUsIcon(true);
      }
    } else {
      setShowAssistantIc(false);
      setWhatsAppIcon(false);
      setCallUsIcon(false);
    }
  };

  const fabInteraction = () => {
    return (
      <div
        className={` ${(() => {
          if (showTripAssistantButtonForDweb && showTripAssistantButton) {
            return '';
          } else if (showTripAssistantButton) {
            return 'mobileShow';
          } else if (showTripAssistantButtonForDweb) {
            return 'desktopShow';
          }
          return '';
        })()}`}
      >
        <div
          onClick={() => {
            trackCityCarTypeTemplateEvent(
              `${
                showModal
                  ? 'Cab_SEO_Assisted_Form_Closed'
                  : 'Cab_SEO_Assisted_Form_CTA_Click'
              }`
            );
            setShowModalWithDelay(!showModal);
            assistedFormLifeCycle.current = 2; // keeping this 2 as for both the cases Closed and Clicked, Assisted form will be shown
          }}
          className={`fabInteraction ${
            showModal && isMobileDevice
              ? 'showCrossIc'
              : showAssistantIc
              ? 'showIc'
              : ''
          }`}
        >
          <div className={`icContainer ${showModal ? 'showCrossIc' : ''}`} />
          {true && <span>Trip Assistant</span>}
        </div>
      </div>
    );
  };

  const callUsForm = () => {
    return (
      <div
        className={` ${(() => {
          if (showCallusModalMweb) {
            return '';
          }
          return '';
        })()}`}
      >
        <div
          onClick={() => {
            trackCityCarTypeTemplateEvent(
              `${
                showModal
                  ? 'Cab_SEO_Assisted_Call_Us_Form_Closed'
                  : 'Cab_SEO_Assisted_Form_CTA_Click'
              }`
            );
            setShowModalWithDelay(!showModal);
            assistedFormLifeCycle.current = 2; // keeping this 2 as for both the cases Closed and Clicked, Assisted form will be shown
          }}
          className={`${
            showModal && isMobileDevice
              ? 'fabInteraction showCrossIc'
              : showAssistantIc
              ? 'showIc'
              : ''
          }`}
        >
          <div className={`icContainer ${showModal ? 'showCrossIc' : ''}`} />
        </div>
      </div>
    );
  };

  const onWhatsAppIconClick = () => {
    const requestId = generateRequestId();
    const pageName = 'seo_city_car_type_page';
    makeServiceDeskRequest(requestId, pageName);
    const whatsAppChatLinkWithRequestId = whatsappWidgetDeeplink
      ? whatsappWidgetDeeplink.replace('MDRequest_id', requestId)
      : '';
    if (whatsAppChatLinkWithRequestId)
      window.location.href = whatsAppChatLinkWithRequestId;
  };

  const onCallUsIconClick = () => {
    window.open(`tel:${customerCareNumberFinal}`, '_blank');
  };

  const handleWhatsappWidget = () => {
    onWhatsAppIconClick();
    trackCityCarTypeTemplateEvent('Cab_SEO_WhatsApp_Assisted_Icon_Clicked');
    setShowWhatsAppTooltip(false);
  };
  const handleTooltipClose = e => {
    e.stopPropagation();
    setShowWhatsAppTooltip(false);
  };

  return (
    <AppContextProvider
      omniUrlArgs={`source=${SEO_CITY_CARTYPE_TEMPLATE}`}
      trackTemplateEvent={trackCityCarTypeTemplateEvent}
      selectedKnowMoreDetailsForMobile={selectedKnowMoreDetailsForMobile}
      setSelectedKnowMoreDetailsForMobile={delayedKnowMoreDetailsForMobile}
    >
      <div>
        {isMobile() && showWhatsappWidget && (
          <div className="whatsapp-wrapper">
            {showWhatsAppTooltip && (
              <div className="whatsapp-tooltip">
                <span className="whatsapp-tooltip-text">
                  {packageData?.tooltipInfo?.text || 'Chat with us on WhatsApp'}
                </span>
                <img
                  onClick={handleTooltipClose}
                  src={`${PUBLIC_URL}/static/public/cross_white_icon.png`}
                  alt="close"
                  className="whatsapp-tooltip-close"
                />
              </div>
            )}
            <div
              className={`${!showModal ? 'whatsApp' : ''} ${
                showModal ? '' : showWhatsAppIcon ? 'showWhatsAppIcon' : ''
              }`}
              onClick={handleWhatsappWidget}
            >
              <div
                className={`${!showModal ? 'whatsaAppIconContainer' : ''}`}
              />
              {true && !showModal && <span>Chat with us</span>}
            </div>
          </div>
        )}
      </div>
      <div>
        {isMobile() && showCallUsWidget && customerCareNumberFinal && (
          <div
            className={`${!showModal ? 'callUs' : ''} ${
              showModal ? '' : showCallUsIcon ? 'showCallUsIcon' : ''
            }`}
            onClick={() => {
              onCallUsIconClick();
              trackCityCarTypeTemplateEvent('Cab_SEO_Call_Us_Icon_Clicked');
            }}
          >
            <div className={`${!showModal ? 'callUsIconContainer' : ''}`} />
            {true && !showModal && <span>Call us now</span>}
          </div>
        )}
      </div>
      {isMobile() && showTripAssistantButton ? fabInteraction() : <div></div>}
      {showCallusModalMweb && callUsForm()}
      {(showTripAssistantButtonForDweb || showLeaveIntentForm) &&
      !isMobile() ? (
        <div className="tripAssistant">
          {showTripAssistantTooltip && (
            <div className="tripassistant-tooltip">
              <span className="tripassistant-tooltip-text">
                {packageData?.tooltipInfo?.text}
              </span>
              <img
                onClick={e => {
                  e.stopPropagation();
                  setShowTripAssistantTooltip(false);
                }}
                src={`${PUBLIC_URL}/static/public/cross_white_icon.png`}
                alt="close"
                className="tripassistant-tooltip-close"
              />
            </div>
          )}
        </div>
      ) : (
        <div className="tripAssistant"></div>
      )}
      {(showTripAssistantButtonForDweb || showLeaveIntentForm) &&
      !isMobile() ? (
        <div className="tripAssistant2">
          <TripAssistant
            customerCareNumber={inboundCallNumberFinal}
            trackEvent={trackCityCarTypeTemplateEvent}
            source={cityName}
            autoOpenDelay={assistedFormOpenDelay}
            couponData={couponInfo}
            showTripAssistant={showTripAssistantButtonForDweb}
            showLeaveIntentForm={showLeaveIntentForm}
          />
        </div>
      ) : (
        <div className="tripAssistant2"></div>
      )}
      {showModal && isMobile() && showTripAssistantButton && (
        <AssistModal
          sourceCity={cityName}
          setShowModal={val => setShowModalWithDelay(val)}
          trackTemplateEvent={trackCityCarTypeTemplateEvent}
          showWhatsAppForAssistedForm={showWhatsAppForAssistedForm}
          showCallUsForAssistedForm={showCallUsForAssistedForm}
          customerCareNumber={customerCareNumberFinal}
          assistantWidgetText={assistantWidgetText}
          onCallUsIconClick={onCallUsIconClick}
          onWhatsAppIconClick={onWhatsAppIconClick}
          showInboundNumberOnAssistedForm={showInboundNumberOnAssistedForm}
          inboundCallNumber={inboundCallNumberFinal}
          inboundCallText={inboundCallText}
        />
      )}
      {showModal && isMobile() && showCallusModalMweb && (
        <CallUsModal
          setShowModal={val => setShowModalWithDelay(val)}
          trackTemplateEvent={trackCityCarTypeTemplateEvent}
          showWhatsAppForAssistedForm={showWhatsAppForAssistedForm}
          showCallUsForAssistedForm={showCallUsForAssistedForm}
          customerCareNumber={customerCareNumberFinal}
          assistantWidgetText={assistantWidgetText}
          onCallUsIconClick={onCallUsIconClick}
          onWhatsAppIconClick={onWhatsAppIconClick}
          showModal={showModal}
        />
      )}
      {packageData && isMobile() && isBottomSheetOpen && !userActionDone() ? (
        <PackagesBottomSheet
          packageData={packageData}
          onClose={handleClose}
          pageUrl={templateData.sampleUrl}
        />
      ) : null}
      {packageData && !isMobile() && shouldShowPackages && !userActionDone() && (
        <PackagesModal
          pageUrl={templateData.sampleUrl}
          packageData={packageData}
          onClose={() => {
            setShouldShowPackages(false);
            // logRttEventLogger({omniUrlArgs:`source=${SEO_CITY_TEMPLATE}`, eventName: 'Cab_Packages_Modal_Closed',pageUrl: templateData.sampleUrl });
            trackCityCarTypeTemplateEvent('Cab_Packages_Modal_Closed');
          }}
          show={true}
        />
      )}
      <div
        className={`cabSeoDtPage ${
          // !collapsableFlag || selectedKnowMoreDetailsForMobile ? 'expanded' :''
          selectedKnowMoreDetailsForMobile ? 'expanded' : ''
        }`}
      >
        <Helmet>
          <title>{templateData.metaTitle}</title>
          <meta name="description" content={templateData.metaDescription} />
          <meta name="keywords" content={templateData.metaKeywords} />
          {templateData.ogTitle && (
            <meta property="og:title" content={templateData.ogTitle} />
          )}
          {templateData.ogDescription && (
            <meta
              property="og:description"
              content={templateData.ogDescription}
            />
          )}
          {templateData.ogImage && (
            <meta name="og:image" content={templateData.ogImage} />
          )}
          {templateData.twitterTitle && (
            <meta name="twitter:title" content={templateData.twitterTitle} />
          )}
          {templateData.twitterDescription && (
            <meta
              name="twitter:description"
              content={templateData.twitterDescription}
            />
          )}
          {templateData.twitterImage && (
            <meta name="twitter:image" content={templateData.twitterImage} />
          )}
          <link rel="canonical" href={templateData.sampleUrl} />
        </Helmet>
        {aggregateRating && (
          <ProductSchema
            data={aggregateRating}
            templateData={templateData}
            schemaMinFare={schemaMinFare}
            source={cityName}
          />
        )}
        <div className={`domChanger mobileShow makeSticky`}>
          <CabModifySearch
            carType={carTypeName}
            isOverlayVisible={isOverlayVisible}
            overlayToggle={toggleOverlay}
            pickupTime={pickUpTime}
            defaultTripType={
              tripType === 'RT' ? OUTSTATION_ROUND_TRIP : travelFor
            }
            returnTime={dropTime}
            isMobileDevice={true}
            title={`${cityName} ${
              TEMPO_TRAVELLER === carTypeName ? TEMPO_TRAVELLER : 'Cabs'
            }`}
            hrPackages={hrPackages}
            sourceCityCode={useCityInTo ? undefined : code}
            sourceCityName={useCityInTo ? undefined : cityName}
            destinationCityCode={useCityInTo ? code : undefined}
            destinationCityName={useCityInTo ? code : undefined}
          />
        </div>

        <div className={`desktopShow makeSticky`}>
          <CabModifySearch
            carType={carTypeName}
            pickupTime={pickUpTime}
            defaultTripType={
              tripType === 'RT' ? OUTSTATION_ROUND_TRIP : travelFor
            }
            returnTime={dropTime}
            returnCloseFlagDefault={tripType === 'RT'}
            isMobileDevice={false}
            title={`${cityName} ${
              TEMPO_TRAVELLER === carTypeName ? TEMPO_TRAVELLER : 'Cabs'
            }`}
            hrPackages={hrPackages}
            sourceCityCode={useCityInTo ? undefined : code}
            sourceCityName={useCityInTo ? undefined : cityName}
            destinationCityCode={useCityInTo ? code : undefined}
            destinationCityName={useCityInTo ? code : undefined}
          />
        </div>
        <main className="container">
          <div className="makeFlex">
            <BreadCrumb breadcrumb={templateData.breadcrumb} />
            {showInboundCallNumberInDesktop ? (
              <InboundCallBox
                inboundCallText={inboundCallText}
                inboundCallNumber={inboundCallNumberFinal}
              />
            ) : (
              <div></div>
            )}
          </div>
          <PageHeader
            title={h1Title(templateData.h1Title)}
            isHtml={true}
            extraInfo={templateData.extraInfo}
            isMobileDevice={isMobileDevice}
            viewMoreHtml={templateData.viewMore}
            viewLessHtml={templateData.viewLess}
          />
          <div>
            {/* {mySafetyHtmls.mySafetyUsp && (
              <div className="appendBottom20">
                <MySafetyBanner html={mySafetyHtmls.mySafetyUsp} />
              </div>
            )} */}
            {packageData && (
              <PackageBanner
                packageData={packageData}
                pageUrl={templateData.sampleUrl}
              />
            )}
          </div>
          {!packageData && templateData.viewMore && templateData.viewLess ? (
            <div className="pageExtraInfo font15 appendTop5">
              <TruncateText
                truncateTextClass="truncateTextContainerCityCarTypeTemplate"
                whiteBackground={false}
                isHtml={true}
                viewMoreHtml={templateData.viewMore}
                viewLessHtml={templateData.viewLess}
                text={templateData.viewLess}
                isMobileDevice={isMobileDevice}
                textLength={0}
              />
            </div>
          ) : (
            <div></div>
          )}
          {topRoutesfromCity.length > 0 && (
            <>
              <section className="">
                <h2>{`Top ${carTypeNameFriendly} ${
                  doNotUseCabsKeyword ? '' : 'Cab'
                } Routes from ${cityName}`}</h2>
                <TopCarTypeCabsRoutes
                  reduceCssCalculations={false}
                  cityName={cityName}
                  routeType="From"
                  data={topRoutesfromCity}
                  carTypeName={carTypeNameFriendly}
                />
              </section>
              <br />
            </>
          )}
          {topRoutesToCity.length > 0 && (
            <>
              <section>
                <h2>{`Top ${carTypeNameFriendly} ${
                  doNotUseCabsKeyword ? '' : 'Cab'
                } Routes to ${cityName}`}</h2>
                <TopCarTypeCabsRoutes
                  cityName={cityName}
                  routeType="To"
                  data={topRoutesToCity}
                  carTypeName={carTypeNameFriendly}
                />
              </section>
              <br />
            </>
          )}
          {!isMobileDevice && templateData.usps.length > 0 && (
            <section className="bookWithUsWrap ">
              <h2>{`Why to Book ${cityName} ${
                doNotUseCabsKeyword ? carTypeNameFriendly : 'Cabs'
              } with Us`}</h2>
              <WhyBookWithUs usps={templateData.usps} />
            </section>
          )}

          <div>
            {isMobileDevice && templateData.usps.length > 0 && (
              <section className="bookWithUsWrap">
                <h2>{`Why Book  with Us`}</h2>
                <WhyBookWithUs usps={templateData.usps} />
              </section>
            )}
          </div>
          {otherCarTypeCabsFromSource &&
            otherCarTypeCabsFromSource.cabTypes &&
            otherCarTypeCabsFromSource.cabTypes.length > 0 && (
              <TopCabsRoutes
                reduceCssCalculations={false}
                h2={`Other Cab Options from ${cityName}`}
                cityName={cityName}
                routeType="From"
                carTypeName={carTypeName}
                data={otherCarTypeCabsFromSource}
              />
            )}
          {/* {mySafetyHtmls.ePassUsp && (
            <div className=" appendBottom40">
              <EpassBnr html={mySafetyHtmls.ePassUsp} />
            </div>
          )} */}
          {/* <br style={{ display: 'none' }} />
          {mySafetyHtmls.stateGuidelines && (
            <section>
              <h2>State Guidelines for e-Passes</h2>
              <StateGuidelines html={mySafetyHtmls.stateGuidelines} />
            </section>
          )} */}
          <div
            style={{ flexWrap: 'wrap' }}
            className={`cabsSeoWrap__Details makeFlex visibilityAuto`}
          >
            {interlinks &&
              interlinks.map(({ title, links }) => {
                return (
                  <CompactList
                    titlePrefix={title}
                    titleSuffix={``}
                    list={links}
                    type={'bullets'}
                    className={'rightMargin'}
                  >
                    {(item: any, idx, style) => (
                      <li
                        key={`${item.text}_${idx}`}
                        className={`${
                          idx ? `paddingT10 paddingB10` : `paddingB10`
                        }`}
                      >
                        {item.url ? (
                          <a
                            className={`linkBoxFont `}
                            onClick={() => {
                              //TO DO: add omniture events from Dataloader
                            }}
                            href={item.url}
                          >
                            {item.text}
                          </a>
                        ) : (
                          <span>{item.text}</span>
                        )}
                      </li>
                    )}
                  </CompactList>
                );
              })}
          </div>
          {templateData.contentList && templateData.contentList.length > 0 && (
            <ContentList contentList={templateData.contentList} />
          )}
          {templateData.faq.length > 0 && (
            <section className="visibilityAuto">
              <h2>
                {carTypeNameFriendly
                  .toLowerCase()
                  .includes(TEMPO_TRAVELLER?.toLowerCase()) ||
                carTypeNameFriendly
                  .toLowerCase()
                  .includes(MINIBUS?.toLowerCase())
                  ? `FAQs: ${carTypeNameFriendly} Hire in ${cityName} `
                  : `Frequently Asked Questions for ${cityName} ${carTypeNameFriendly} ${
                      doNotUseCabsKeyword ? '' : 'Cab'
                    } Booking`}
              </h2>
              <FaqSection
                trackTemplateEvent={trackCityCarTypeTemplateEvent}
                data={templateData.faq}
                pageUrl={templateData.sampleUrl}
              />
            </section>
          )}
          {/* {templateData?.descriptionInHtml && (
            <section>
              <h2>{`${cityName} Tempo traveller Booking on MMT`}</h2>
              <ThingsToKnow html={templateData?.descriptionInHtml} />
            </section>
          )}
          {cityDescription && (
            <section className="visibilityAuto">
              <h2>{`Things To Know About ${cityName}`}</h2>
              <ThingsToKnow text1={cityDescription} />
            </section>
          )} */}
        </main>
        {selectedKnowMoreDetailsForMobile ? (
          <Overlay
            cancelButton={() => delayedKnowMoreDetailsForMobile(null)}
            knowMoreDetails={selectedKnowMoreDetailsForMobile}
          />
        ) : null}
        <Footer template={templateData} />
        <div
          className="blackOverlay"
          onClick={() => {
            delayedKnowMoreDetailsForMobile(null);
          }}
        ></div>
        {isOverlayVisible && (
          <div
            onClick={() => {
              toggleOverlay(false);
            }}
            className="searchWidgetModal mobileShow"
          ></div>
        )}
      </div>
    </AppContextProvider>
  );
};

CityCarTypeTemplate.fetchData = async (_, match, urlObj) => {
  const {
    params: { cityCarTypeId }
  } = match;
  const url = `${DATA_LOADER_URL}/api/cityCarTypeTemplateData/${cityCarTypeId}?${urlObj.query}`;
  let responseData;
  const response = await fetch(url);
  const textResponse = await response.text();

  try {
    responseData = JSON.parse(textResponse);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('url', url);
    throw new Error('JSON parse exception: ' + textResponse);
  }
  if (responseData.status !== 'SUCCESS') {
    // eslint-disable-next-line no-console
    console.error('url', url);
    throw new DataLoaderError(
      `Unable to fetch city details of ${cityCarTypeId}`,
      responseData.error
    );
  }
  return responseData;
};
export default CityCarTypeTemplate;
